var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#F43838",
      "transform": "translate(-346 -20)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M358 40.1c4.474 0 8.1-3.626 8.1-8.1s-3.626-8.1-8.1-8.1-8.1 3.626-8.1 8.1 3.626 8.1 8.1 8.1zm0 .9c-4.97 0-9-4.03-9-9s4.03-9 9-9 9 4.03 9 9-4.03 9-9 9zm-4.5-8.55c-.249 0-.45-.201-.45-.45s.201-.45.45-.45h9c.249 0 .45.201.45.45s-.201.45-.45.45h-9z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }